<div class="my-container" [hidden]="!loading">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>

<div mat-dialog-title class="matDialogTitle">
    <span *ngIf="lang == 1"> جستجو </span>
    <span *ngIf="lang == 2">Search</span>
    <span class="close" (click)="close()">
        <mat-icon>close</mat-icon>
    </span>
</div>


<div mat-dialog-content class="MatDialogContent">
    <div class='col-md-2 col-lg-2 col-sm-2 col-xs-12 pe' [ngClass]="{en:lang==2}">
        <label for="title" class='wh-label'>
            <span *ngIf="lang == 1"> درخواست کننده : </span>
            <span *ngIf="lang == 2"> PR No : </span>

            <span (click)="reset_input(24)">
                <mat-icon class="close" class="input_search input_search_pe" [ngClass]="{input_search_en:lang==2}">close
                </mat-icon>
            </span>
            <input class="wh-input" name="user_title" [(ngModel)]="user_title" (keyup.enter)="search(1)"
                (click)="load_services(24) " readonly>
            <input class="wh-input" name="user" [(ngModel)]="user" readonly [hidden]="true">

        </label>
    </div>

    <div class='col-md-2 col-lg-2 col-sm-2 col-xs-12 pe' [ngClass]="{en:lang==2}">
        <label for="title" class='wh-label'>
            <span *ngIf="lang == 1"> شماره فاکتور : </span>
            <span *ngIf="lang == 2"> PR No : </span>
            <input class='wh-input' type="search" name='code_factor' [(ngModel)]='code_factor' pattern="[0-9]{1,}"
                (keyup.enter)="search(1)" autocomplete="off">
        </label>
    </div>

    <div class='col-md-2 col-lg-2 col-sm-2 col-xs-12 pe' [ngClass]="{en:lang==2}">
        <label for="title" class='wh-label'>
            <span *ngIf="lang == 1"> هزینه سازه 1KG تومان : </span>
            <span *ngIf="lang == 2"> --- : </span>
            <input class='wh-input' type="search" name='price' [(ngModel)]='price' pattern="[0-9]{1,}"
                (keyup.enter)="search(1)" autocomplete="off">
        </label>
    </div>


    <div class='col-md-2 col-lg-2 col-sm-2 col-xs-12 pe' [ngClass]="{en:lang==2}">
        <label for="title" class='wh-label'> ارزش افزوده :
            <select class="wh-input" name='percent' [(ngModel)]="percent">
                <option></option>
                <option *ngFor="let x of list_percent" value='{{ x.status_id }}'>{{ x.status_title2 }}
                </option>
            </select>
        </label>
    </div>

    <div class='col-md-2 col-lg-2 col-sm-2 col-xs-12 pe' [ngClass]="{en:lang==2}">
        <label for="title" class='wh-label'> پیچ :
            <select class="wh-input" name='bullet' [(ngModel)]="bullet">
                <option></option>
                <option *ngFor="let x of list_bullet" value='{{ x.status_id }}'>{{ x.status_title2 }}
                </option>
            </select>
        </label>
    </div>
    <!-- ************************************************************************************************************************************************ -->
    <div class='col-md-12 col-lg-12 col-sm-12 col-xs-12 pe' [ngClass]="{en:lang==2}">
        <label for="status_id" class='wh-label'>
            <div *ngIf="lang == 1"> سال : </div>
            <mat-checkbox class="pe1" [ngClass]="{en1:lang==2}" *ngFor='let x of list_year;let i = index'
                value="{{ x.site_year_value }}" (change)="select_year_search()" name='year_search[]'
                [checked]="year.indexOf(x.site_year_value) != -1 ">
                {{ x.site_year_title }}</mat-checkbox>
        </label>
    </div>

    <div class='col-md-12 col-lg-12 col-sm-12 col-xs-12 pe' [ngClass]="{en:lang==2}">
        <label for="status_id" class='wh-label'>
            <div *ngIf="lang == 1"> نوع ساحتمان : </div>
            <mat-checkbox class="pe1" [ngClass]="{en1:lang==2}" *ngFor='let x of list_floor;let i = index'
                value="{{ x.shop_shop_floor_id }}" (change)="select_floor_search()" name='floor_search[]'
                [checked]="floor.indexOf(x.shop_shop_floor_id) != -1 ">
                {{ x.shop_shop_floor_title }}</mat-checkbox>
        </label>
    </div>



    <div class='col-md-12 col-lg-12 col-sm-12 col-xs-12 pe' [ngClass]="{en:lang==2}">
        <label for="status_id" class='wh-label'>
            <div *ngIf="lang == 1"> دهانه ساختمان : </div>
            <mat-checkbox class="pe1" [ngClass]="{en1:lang==2}" *ngFor='let x of list_crater;let i = index'
                value="{{ x.shop_crater_id }}" (change)="select_crater_search()" name='crater_search[]'
                [checked]="crater.indexOf(x.shop_crater_id) != -1 ">
                {{ x.title }}</mat-checkbox>
        </label>
    </div>


    <div class='col-md-12 col-lg-12 col-sm-12 col-xs-12 pe' [ngClass]="{en:lang==2}">
        <label for="status_id" class='wh-label'>
            <div *ngIf="lang == 1"> نوع سقف آخر : </div>
            <mat-checkbox class="pe1" [ngClass]="{en1:lang==2}" *ngFor='let x of list_type_ceil;let i = index'
                value="{{ x.shop_type_ceil_id }}" (change)="select_type_ceil_search()" name='type_ceil_search[]'
                [checked]="type_ceil.indexOf(x.shop_type_ceil_id) != -1 ">
                {{ x.shop_type_ceil_title }}</mat-checkbox>
        </label>
    </div>

    <div class='col-md-12 col-lg-12 col-sm-12 col-xs-12 pe' [ngClass]="{en:lang==2}">
        <label for="status_id" class='wh-label'>
            <div *ngIf="lang == 1"> موقعیت اجرا : </div>
            <mat-checkbox class="pe1" [ngClass]="{en1:lang==2}"
                *ngFor='let x of list_install_run_position;let i = index' value="{{ x.shop_install_run_position_id }}"
                (change)="select_install_run_position_search()" name='install_run_position_search[]'
                [checked]="install_run_position.indexOf(x.shop_install_run_position_id) != -1 ">
                {{ x.shop_install_run_position_title }}</mat-checkbox>
        </label>
    </div>

    <div class='col-md-12 col-lg-12 col-sm-12 col-xs-12 pe' [ngClass]="{en:lang==2}">
        <label for="status_id" class='wh-label'>
            <div *ngIf="lang == 1"> امکانات سایت : </div>
            <mat-checkbox class="pe1" [ngClass]="{en1:lang==2}" *ngFor='let x of list_install_site;let i = index'
                value="{{ x.shop_install_site_id }}" (change)="select_install_site_search()"
                name='install_site_search[]' [checked]="install_site.indexOf(x.shop_install_site_id) != -1 ">
                {{ x.shop_install_site_title }}</mat-checkbox>
        </label>
    </div>

    <div class='col-md-12 col-lg-12 col-sm-12 col-xs-12 pe' [ngClass]="{en:lang==2}">
        <label for="status_id" class='wh-label'>
            <div *ngIf="lang == 1"> حداکثر دهانه بازشو m : </div>
            <mat-checkbox class="pe1" [ngClass]="{en1:lang==2}" *ngFor='let x of list_install_open_crater;let i = index'
                value="{{ x.shop_install_open_crater_id }}" (change)="select_install_open_crater_search()"
                name='install_open_crater_search[]'
                [checked]="open_crater.indexOf(x.shop_install_open_crater_id) != -1 ">
                {{ x.shop_install_open_crater_title }}</mat-checkbox>
        </label>
    </div>

    <div class='col-md-12 col-lg-12 col-sm-12 col-xs-12 pe' [ngClass]="{en:lang==2}">
        <label for="status_id" class='wh-label'>
            <div *ngIf="lang == 1"> ارتفاع طبقات m : </div>
            <mat-checkbox class="pe1" [ngClass]="{en1:lang==2}" *ngFor='let x of list_install_height;let i = index'
                value="{{ x.shop_install_height_id }}" (change)="select_install_height_search()"
                name='install_height_search[]' [checked]="install_height.indexOf(x.shop_install_height_id) != -1 ">
                {{ x.shop_install_height_title }}</mat-checkbox>
        </label>
    </div>

    <div class='col-md-12 col-lg-12 col-sm-12 col-xs-12 pe' [ngClass]="{en:lang==2}">
        <label for="status_id" class='wh-label'>
            <div *ngIf="lang == 1"> مکان نصب : </div>
            <mat-checkbox class="pe1" [ngClass]="{en1:lang==2}" *ngFor='let x of list_install_place;let i = index'
                value="{{ x.shop_install_place_id }}" (change)="select_install_place_search()"
                name='install_place_search[]' [checked]="install_place.indexOf(x.shop_install_place_id) != -1 ">
                {{ x.shop_install_place_title }}</mat-checkbox>
        </label>
    </div>

    <div class='col-md-12 col-lg-12 col-sm-12 col-xs-12 pe' [ngClass]="{en:lang==2}">
        <label for="status_id" class='wh-label'>
            <div *ngIf="lang == 1"> وضعیت ها : </div>
            <mat-checkbox class="pe1" [ngClass]="{en1:lang==2}" *ngFor='let x of list_sale_process;let i = index'
                value="{{ x.sale_process_id }}" (change)="select_sale_process_search()" name='process_search[]'
                [checked]="process.indexOf(x.sale_process_id) != -1 ">
                {{ x.sale_process_title }}</mat-checkbox>
        </label>
    </div>



    <!-- ************************************************************************************************************************************************ -->

</div><!-- mat-dialog-content -->





<div mat-dialog-actions align="end" class="matDialogActions pe" [ngClass]="{en:lang==2}">
    <div class='col-md-12' style='margin-top:5px;text-align:center;font-family:irsans' *ngIf="lang == 1 ">
        <button class="btn_pe" [ngClass]="{btn_en:lang==2}" (click)="search(1)">جستجو</button>
        <button class="btn_pe" [ngClass]="{btn_en:lang==2}" (click)="search(2)">خروجی اکسل</button>
        <div *ngIf="waiting_excell == 2" style="font-size:10px">لطفا تا آماده شدن فایل صبر کنید...</div>
        <div *ngIf="show_excell == 2 "><a href="{{ site }}/export/{{ export_code }}.xlsx">Download File</a></div>
    </div>
    <div class='col-md-12' style='margin-top:5px;text-align:center;font-family:en' *ngIf="lang == 2 ">
        <button class="btn_pe" [ngClass]="{btn_en:lang==2}" (click)="search(1)">Search</button>
        <button class="btn_pe" [ngClass]="{btn_en:lang==2}" (click)="search(2)">Export Excel</button>
        <div *ngIf="waiting_excell == 2" style="font-size:10px">Please waiting....</div>
        <div *ngIf="show_excell == 2 "><a href="{{ site }}/export/{{ export_code }}.xlsx">Download File</a></div>
    </div>
</div>